import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';

const GetPrebuiltMacros = new ReduxAsyncAction('AD_PARTNER_GET_PREBUILT_MACROS');
GetPrebuiltMacros.registerRequest(async (machineName: string) => {
  const { data } = await dash_api.get(`/v1/ad-network/prebuilt-macros/${machineName}`);
  return data;
});
export const GET_PREBUILT_MACROS = GetPrebuiltMacros.constants;
export const getPrebuiltMacros = GetPrebuiltMacros.request;

const ParseUrl = new ReduxAsyncAction('AD_PARTNER_PARSE_URL');
ParseUrl.registerRequest(async (url: string) => {
  const { data } = await dash_api.post('/v1/ad-network/parse-url', { url });
  return data;
});
export const PARSE_URL = ParseUrl.constants;
export const parseUrl = ParseUrl.request;
